export default __webpack_public_path__ + "static/media/retos.dcf28273.png";